import React from "react"
import { ISimpleTime } from "../../models"
import SimpleTimeEditor from "./SimpleTimeEditor"
import { grey500, red500 } from "material-ui/styles/colors"
interface IProps {
    style?: React.CSSProperties
    label?: string
    simpleTime?: ISimpleTime
    readonly?: boolean
    error?: string
    handleChange(simpleTime: ISimpleTime): void
}

const IconSimpleTimeEditor: React.SFC<IProps> = (props: IProps) => {
    let style: React.CSSProperties = { display: "flex", position: "relative" }
    if (props.style)
        style = { ...style, ...props.style }
    return (
        <div style={style}>
            <i className="fa fa-clock-o" style={{ marginRight: 7, marginTop: 41, fontSize: 15, color: grey500 }} />
            <div>
                <SimpleTimeEditor
                    readonly={props.readonly}
                    label={props.label}
                    simpleTime={props.simpleTime}
                    handleChange={props.handleChange}
                />
            </div>
            {props.error &&
                <div style={{ position: "absolute", bottom: -15, left: 20, fontSize: 12, color: red500 }}>{props.error}</div>
            }
        </div>
    )
}

export default IconSimpleTimeEditor